import JSONData from "../variables/variables.json";
import classNames from "classname";
import Image from "next/image";
import TranslatedMessage from "./TranslatedMessage";
import LinkTo from "./mdx/LinkTo";
import Link from "next/link";

const Carousel = (props) => {
	let propsMiasto = props.miasto;
	let propsPodatek = props.podatek;
	let propsIndex = props.index;

	const miastoVariable = "miasta." + propsMiasto;
	const carousel = "carousel";

	const firstButton =
		miastoVariable +
		"." +
		carousel +
		"." +
		[propsPodatek] +
		"." +
		[propsIndex] +
		".action.firstButton.title";

	const secondButton =
		miastoVariable +
		"." +
		carousel +
		"." +
		[propsPodatek] +
		"." +
		[propsIndex] +
		".action.secondButton.title";

	const miastoJSON = JSONData.miasta[propsMiasto];
	const carouselItem = miastoJSON.carousel[propsPodatek][propsIndex];

	const carouselTitle =
		miastoVariable + "." + carousel + "." + propsPodatek + "." + propsIndex + ".header.title";

	const carouselSubtitle =
		miastoVariable + "." + carousel + "." + propsPodatek + "." + propsIndex + ".header.subtitle";

	const carouselImg = carouselItem.header.images;

	const dataMicroModalTrigger = carouselItem.name?.shortName || carouselItem.name?.data || "";

	const startUrl = miastoJSON.test
		? "https://test.przyjazne-deklaracje.pl/"
		: "https://przyjazne-deklaracje.pl/";

	const profileCode = "O4B";
	const templateCode = carouselItem.templateCode;
	const templateScope = miastoJSON.templateScope;

	const templateScopeFull = miastoJSON.index ? "" : "&templateScope=" + templateScope;

	const linkTo =
		startUrl +
		"kalkulatory/menadzer/menadzer-kalkulatorow?profileCode=" +
		profileCode +
		"&templateCode=" +
		templateCode +
		templateScopeFull;

	const Hero = (props) => (
		<section
			className={classNames("pd-hero", {
				small: props.small,
				slider: props.slider,
			})}
			style={{
				position: "relative",
			}}
		>
			{props.children}
		</section>
	);

	const HeroTop = (props) => (
		<div
			className="pd-hero__top"
			style={{
				position: "relative",
				zIndex: 5,
			}}
		>
			<div className="pd-hero__header">{props.children}</div>
		</div>
	);

	const HeroTitleH1 = (props) => (
		<h1 className="pd-hero__header__title" id={props.id}>
			{props.children}
		</h1>
	);

	const HeroTitleH2 = (props) => (
		<h2 className="pd-hero__header__title" id={props.id}>
			{props.children}
		</h2>
	);

	const HeroSubtitle = (props) => <p className="pd-hero__header__subtitle">{props.children}</p>;

	const HeroImage = (props) => (
		<div
			className="pd-hero__image"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</div>
	);

	const HeroImageDesktop = (props) => (
		<div
			className="pd-hero__image__img desktop"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</div>
	);

	const HeroImageTablet = (props) => (
		<div
			className="pd-hero__image__img tablet"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</div>
	);

	const HeroImageMobile = (props) => (
		<div
			className="pd-hero__image__img mobile"
			style={{
				pointerEvents: "none",
			}}
		>
			{props.children}
		</div>
	);

	return (
		<>
			<Hero small={props.small} slider={props.slider}>
				<HeroTop>
					{props.tagTitle === "h1" && (
						<HeroTitleH1>
							<TranslatedMessage id={carouselTitle} />
						</HeroTitleH1>
					)}

					{props.tagTitle === "h2" && (
						<HeroTitleH2>
							<TranslatedMessage id={carouselTitle} />
						</HeroTitleH2>
					)}

					<HeroSubtitle>
						<TranslatedMessage id={carouselSubtitle} />
					</HeroSubtitle>
				</HeroTop>

				{carouselItem.action.available === true && (
					<div
						className="pd-hero__action"
						style={{
							position: "relative",
							zIndex: 10,
						}}
					>
						<div
							className={classNames("pd-hero__action__inner", {
								"pd-hero__action--two-buttons": carouselItem.action.secondButton.available,
								"pd-hero__action--to-left": props.small,
							})}
							style={{
								position: "relative",
								zIndex: 11,
							}}
						>
							{carouselItem.action.firstButton.scrollTo ? (
								<LinkTo to="wypelnij-deklaracje" className="pd-btn pd-btn--primary">
									<TranslatedMessage id={firstButton} />
								</LinkTo>
							) : carouselItem.action.firstButton.turnModal ? (
								<button
									type="button"
									data-a11y-dialog-show={dataMicroModalTrigger}
									aria-haspopup="dialog"
									aria-controls={dataMicroModalTrigger}
									className="pd-btn pd-btn--primary"
									style={{
										position: "relative",
										zIndex: 12,
										touchAction: "manipulation",
									}}
								>
									<TranslatedMessage id={firstButton} />
								</button>
							) : carouselItem.action.firstButton.turnUrl ? (
								<Link href={carouselItem.action.firstButton.url} className="pd-btn pd-btn--primary">
									<TranslatedMessage id={firstButton} />
								</Link>
							) : (
								<Link href={linkTo} className="pd-btn pd-btn--primary">
									<TranslatedMessage id={firstButton} />
								</Link>
							)}

							{carouselItem.action.secondButton.available === true && (
								<LinkTo to="czytaj-wiecej" className="pd-btn pd-btn--outline read-more">
									<TranslatedMessage id={secondButton} />
								</LinkTo>
							)}
						</div>
					</div>
				)}

				<HeroImage>
					<HeroImageDesktop>
						<Image
							unoptimized
							alt=""
							src={carouselImg.desktop}
							quality={100}
							fill={true}
							sizes="100vw"
							style={{
								objectFit: "contain",
								objectPosition: "right bottom",
								pointerEvents: "none",
							}}
						/>
					</HeroImageDesktop>

					<HeroImageTablet>
						<Image
							unoptimized
							alt=""
							src={carouselImg.tablet}
							quality={100}
							fill={true}
							sizes="100vw"
							style={{
								objectFit: "contain",
								objectPosition: "right bottom",
								pointerEvents: "none",
							}}
						/>
					</HeroImageTablet>

					<HeroImageMobile>
						<Image
							unoptimized
							alt=""
							src={carouselImg.mobile}
							width="880"
							height="488"
							quality={100}
							sizes="100vw"
							style={{
								width: "100%",
								height: "auto",
								pointerEvents: "none",
							}}
						/>
					</HeroImageMobile>
				</HeroImage>
			</Hero>
		</>
	);
};

export default Carousel;
